const wAny = typeof window === "object" ? (window as any) : {}

wAny.dataLayer = wAny.dataLayer || []

if (!wAny.gtag) {
  wAny.gtag = (...args: any[]) => {
    wAny.dataLayer.push(args)
  }
}

export function trackEvent(evtName: string, name?: string, params: any = {}) {
  console.log("GA", { evtName, name, ...params })
  wAny.gtag("event", evtName, {
    name: name,
    ...params,
  })
}
